/* $('.SizeSwatch:first-child').addClass('Custom-SizeSwatch');

$('.show-only-pp-div li.HorizontalList__Item').click(function() {
    $('.SizeSwatch').toggleClass('Custom-SizeSwatch');
  $('.show-only-pp-div .SizeSwatch:first-child').removeClass('Custom-SizeSwatch');
});

$(".show-only-pp-div li.HorizontalList__Item").click(function() {
  $(this).addClass('active')
         .parent().siblings().children().removeClass('active');
});
*/

var selector = ".show-only-pp-div li.HorizontalList__Item";

$(selector).on("click", function () {
  $(selector).removeClass("active");
  $(this).addClass("active");
});

(function () {
  var touchingCarousel = false,
    touchStartCoords;

  document.body.addEventListener("touchstart", function (e) {
    if (e.target.closest(".flickity-slider")) {
      touchingCarousel = true;
    } else {
      touchingCarousel = false;
      return;
    }

    touchStartCoords = {
      x: e.touches[0].pageX,
      y: e.touches[0].pageY,
    };
  });

  document.body.addEventListener(
    "touchmove",
    function (e) {
      if (!(touchingCarousel && e.cancelable)) {
        return;
      }

      var moveVector = {
        x: e.touches[0].pageX - touchStartCoords.x,
        y: e.touches[0].pageY - touchStartCoords.y,
      };

      if (Math.abs(moveVector.x) > 7) e.preventDefault();
    },
    { passive: false }
  );
})();

// best-fit-size-chart app position change
const move_size_btn = () => {
  let current = 0;
  const my_interval = setInterval(() => {
    const best_fit_size_chart = document.querySelector(".best-fit-size-chart");
    const variant_swatch_king = document.querySelector("variant-swatch-king");
    current++;
    if (best_fit_size_chart && variant_swatch_king) {
      const size = variant_swatch_king.querySelector('[sa-options-position="default"]');
      if(variant_swatch_king.querySelector('#swatch-option2')){
      best_fit_size_chart.style.bottom = variant_swatch_king.querySelector('#swatch-option2 > div').offsetHeight - 25 + 'px';
      }else{
      best_fit_size_chart.style.bottom = variant_swatch_king.querySelector('#swatch-option1 > div').offsetHeight - 25 + 'px';
      }

      size.appendChild(best_fit_size_chart);
      clearInterval(my_interval);
    }
    if (current > 10 || (best_fit_size_chart && variant_swatch_king)) {
      clearInterval(my_interval);
    }
  }, 1000);
};

move_size_btn();